// apps/web/src/admin/AdminGuidesView.tsx
import { useEffect, useState } from 'react';
import { apiAdmin } from './apiAdmin.js';
import { UserDetailDrawer } from './UserDetailDrawer.js';
import { ExportPdfButton } from './ExportPdfButton.js';
import { last30DaysStartIso, reportTimestamp } from './reportWindow.js';

export function AdminGuidesView() {
  const [data, setData] = useState<any | null>(null);
  const [open, setOpen] = useState<string | null>(null);
  async function load() { setData(await apiAdmin.guides()); }
  useEffect(() => { void load(); }, []);

  async function exportPdf() {
    const { generateReportPdf } = await import('./reportPdf.js');
    const now = new Date();
    const res = await apiAdmin.guides({ since: last30DaysStartIso(now) });
    const rows: any[] = res.guides;
    generateReportPdf({
      title: 'Guides Report',
      subtitle: `Created in the last 30 days · Generated ${reportTimestamp(now)}`,
      summary: [['New guides', String(rows.length)]],
      tables: [{
        columns: ['Name', 'Email', 'Earned $', 'Owed $', 'MTD min', 'Rating', 'Signup', 'Last seen'],
        rows: rows.map((g) => [
          g.displayName, g.email, g.lifetimeEarnedDollars.toFixed(2), g.owed.toFixed(2), g.mtdMinutes,
          g.ratingAvg != null ? `${g.ratingAvg.toFixed(2)} (${g.ratingCount})` : '—',
          g.signupAt ? new Date(g.signupAt).toLocaleDateString() : '—',
          g.lastSeenAt ? new Date(g.lastSeenAt).toLocaleDateString() : '—',
        ]),
      }],
      filename: 'guides-created-last-30-days.pdf',
    });
  }

  if (!data) return <p>Loading…</p>;
  return (
    <div>
      <div className="flex justify-end mb-3"><ExportPdfButton onExport={exportPdf} /></div>
      <table className="w-full text-sm">
        <thead className="text-left text-ink-500"><tr><th>Name</th><th>Earned</th><th>Owed</th><th>MTD min</th><th>Rating</th><th>Last seen</th></tr></thead>
        <tbody>
          {data.guides.map((g: any) => (
            <tr key={g.id} onClick={() => setOpen(g.id)} className="cursor-pointer hover:bg-ink-50">
              <td>{g.displayName}</td><td>${g.lifetimeEarnedDollars.toFixed(2)}</td><td>${g.owed.toFixed(2)}</td>
              <td>{g.mtdMinutes}</td>
              <td>{g.ratingAvg != null ? `${g.ratingAvg.toFixed(2)} (${g.ratingCount})` : '—'}</td>
              <td>{g.lastSeenAt ? new Date(g.lastSeenAt).toLocaleString() : '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {open ? <UserDetailDrawer userId={open} onClose={() => setOpen(null)} onChange={load} /> : null}
    </div>
  );
}
